import { Role, Variable } from '../data/interfaces/DocumentTemplate';
import { InputStatus, InputValidation } from '../data/interfaces/form';
import { t } from '.';

export const emailValidator = (emailInputValue: string) => {
	const validationResult = {
		isValid: true,
		errorMessage: null,
	};

	if (!emailInputValue) {
		validationResult.isValid = false;
		validationResult.errorMessage = t('fieldRequired');
	} else {
		const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
		if (!emailRegex.test(emailInputValue)) {
			validationResult.isValid = false;
			validationResult.errorMessage = t('invalidEmail');
		}
	}
	return validationResult;
};

export const stringValidator = (nameInputValue: string) => {
	const validationResult = {
		isValid: true,
		errorMessage: null,
	};

	if (!nameInputValue) {
		validationResult.errorMessage = t('fieldRequired');
		validationResult.isValid = false;
	}
	return validationResult;
};

export function validatePasscode(value) {
	let status: InputStatus = 'success';
	let message = '';

	if (isNaN(value)) {
		status = 'error';
		message = t('SendSignatureRequest.securityOptions.passcodeOnlyDigits');
	} else if (value.length !== 5) {
		status = 'error';
		message = t('SendSignatureRequest.securityOptions.passcodeLengthError');
	}

	return { status, message };
}

export function validateName(value, errorMessage): InputValidation {
	if (!value?.trim()) {
		return { status: 'error', message: t('fieldRequired') };
	}

	const isValidName = /^[A-Za-z0-9_ ]+$/i.test(value);
	if (!isValidName) {
		return { status: 'error', message: errorMessage };
	}

	return { status: 'success', message: '' };
}

export const validateRoles = (roles: Role[]) => {
	let errorMessage = '';
	if (!roles) {
		return errorMessage;
	}

	for (const role of roles) {
		if (!role.name) {
			errorMessage = t('invalidRoleErrorMessage');
			break;
		} else if (isValidRoleName(role.name) === false) {
			errorMessage = t('roleNameValidationError');
			break;
		}
	}
	if (errorMessage) {
		return errorMessage;
	}

	if (!checkHasUniqueNames(roles)) {
		errorMessage = t('roleNameUniqueError');
	}
	return errorMessage;
};

export const validateVariables = (variables: Variable[]) => {
	let errorMessage = '';
	if (!variables) {
		return errorMessage;
	}

	for (const variable of variables) {
		if (!variable.connectionRID) {
			errorMessage = t('variables.errorMessages.invalidDataSource');
			break;
		}

		if (!variable.entity) {
			errorMessage = t('variables.errorMessages.invalidSourceRecord');
			break;
		}

		if (!variable.name) {
			errorMessage = t('variables.errorMessages.invalidName');
			break;
		}

		const { status, message } = validateName(
			variable.name,
			t('variableNameValidationError')
		);

		if (status === 'error') {
			errorMessage = message;
			break;
		}
	}

	if (errorMessage) {
		return errorMessage;
	}

	if (!checkHasUniqueNames(variables)) {
		errorMessage = t('variables.errorMessages.uniqueName');
	}
	return errorMessage;
};

const checkHasUniqueNames = (values: Variable[] | Role[]) => {
	const valueSet = new Set<string>();

	values.forEach((value: Variable | Role) => {
		valueSet.add(value.name.toLowerCase());
	});

	return valueSet.size === values.length;
};

export function isValidRoleName(str) {
	const strRegex = new RegExp(/^[A-Za-z0-9_ ]+$/i); //allow alpha numeric, white space and underscore
	return strRegex.test(str);
}

export function isUniqueName(name: string, values: Variable[] | Role[]) {
	return (
		values?.filter(value => {
			return value.name.toLowerCase() === name.toLowerCase();
		}).length === 1
	);
}
